export default "__VITE_ASSET__C_23BAve__"